import { useMutation } from '@tanstack/react-query';

import { useStoreApi } from '../api';
import { PurchasesSearch } from './search.types';

const useExportUserPurchaseHistory = () => {
  const StoreApi = useStoreApi();

  const sendUserPurchaseHistory = async (searchReq: PurchasesSearch) => {
    const { data } = await StoreApi.post(`/consumer/cart_items/export?join=AND`, searchReq);
    return data;
  };

  return useMutation({
    mutationFn: sendUserPurchaseHistory,
    // TODO: update keys with queryKeyFactory
    mutationKey: ['store', 'cart_items', 'export'],
  });
};

export { useExportUserPurchaseHistory };
